import { STORAGE_KEYS } from "@/common/constants/storage-keys";

type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

export class LocalStorage {
	private static validKeys = new Set(Object.values(STORAGE_KEYS));

	static set(key: StorageKey, value: string): void {
		if (!LocalStorage.validKeys.has(key)) return;
		localStorage.setItem(key, value);
	}

	static get(key: StorageKey): string | undefined {
		if (!LocalStorage.validKeys.has(key)) return undefined;
		return localStorage.getItem(key) ?? undefined;
	}

	static remove(key: StorageKey): void {
		if (!LocalStorage.validKeys.has(key)) return;
		localStorage.removeItem(key);
	}
}
